import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import BackOfficeLayout from "../../../components/backoffice-layout";
import InputSearchComponent from "../../../components/input-search";
import ButtonComponent from "../../../components/button";
import PaginatorComponent from "../../../components/paginator";
import IconPlus from "../../../assets/images/icon-plus-1.svg"
import { useNavigate } from "react-router-dom";
import CoreAPI from "../../../services/core";
import LoadingModal from "../../../components/loading-modal";
import DeleteModal from "../../../components/modal/delete";
import SuccessModal from "../../../components/modal/success";
import DropdownFilterComponent from "../../../components/evaluation-form-components/dropdown-filter";
import TableEFComponent from "../../../components/table-ef";
import EFQRcodeModal from "../../../components/modal/ef-qrcode";

const Container = styled.div`
    width: calc(100% - 32px);
    background-color: #FFFFFF;
    padding: 40px 16px;
    border-radius: 16px;

    .header-box {
        display: flex;
        justify-content: space-between;
        margin-bottom: 24px;

        .header-label {
            width: fit-content;
            color: #25368D;
            font-size: 20px;
            font-weight: 600;
            line-height: 29.9px;
            text-align: left;
            padding: 2px;
            border-width: 0px 0px 3px 0px;
            border-style: solid;
            border-color: #25368D;
        }
    }


    .filter-bar {
        display: flex;
        flex-direction: column;
        gap: 16px;
        margin-bottom: 36px;

        .multi-box {
            display: flex;
            gap: 24px;

            .multi-select {
                width: calc(100% - 162px);
                display: flex;
                gap: 16px;

                .line {
                    width: 1px;
                    height: calc(100% - 16px);
                    margin-top: 20px;
                    background-color: #F2F2F2;
                }
            }
        }
    }

    .data-box {
        display: flex;
        flex-direction: column;
        gap: 24px;
    }
`;


function EFManagementPage() {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [pageOption, setPageOption] = useState({
        limit: 10,
        page: 1,
        total_item: 0,
        total_page: 1,
    });
    const [orderOption, setOrderOption] = useState({
        order: "DESC",
        orderBy: "evaluation_name",
    });
    const [isLoading, setIsLoading] = useState(false);
    const [listData, setListData] = useState([]);
    const [dataFocus, setDataFocus] = useState(null);
    const [detailModal, setDetailModal] = useState({
        title: "",
        sub_title: "",
    });
    const [openModal, setOpenModal] = useState(false);
    const [detailSuccessModal, setDetailSuccessModal] = useState({
        title: "ลบสมาชิกสำเร็จ",
        sub_title: "",
        type: "success",
        button_label: "กลับหน้าหลัก",
    });
    const [openSuccessModal, setOpenSuccessModal] = useState(false);
    const [openQRcodeModal, setOpenQRcodeModal] = useState(false);
    const [listTypeEF, setListTypeEF] = useState([
        { id: 1, label: "Place" },
        { id: 2, label: "Event" },
        { id: 3, label: "Service" },
    ]);
    const [listDepartment, setListDepartment] = useState([]);
    const [listDivisionDefault, setListDivisionDefault] = useState([]);
    const [listDivision, setListDivision] = useState([]);
    const [listProvince, setListProvince] = useState([]);
    const [listLocationDefault, setListLocationDefault] = useState([]);
    const [listLocation, setListLocation] = useState([]);

    const [listTypeEFSelect, setListTypeEFSelect] = useState([
        { id: 1, label: "Place" },
        { id: 2, label: "Event" },
        { id: 3, label: "Service" },
    ]);
    const [listDepartmentSelect, setListDepartmentSelect] = useState([]);
    const [listDivisionSelect, setListDivisionSelect] = useState([]);
    const [listProvinceSelect, setListProvinceSelect] = useState([]);
    const [listLocationSelect, setListLocationSelect] = useState([]);

    useEffect(() => {
        onInit();
    }, [])

    async function onInit() {
        setIsLoading(true);
        let _profile = localStorage.getItem("profile");
        try {
            _profile = JSON.parse(_profile)
        } catch { }
        let responseDepartment = [];
        let responseDivision = [];
        if (_profile) {
            if (_profile.user_department_id) {
                responseDepartment = await onGetDepartmentById(_profile.user_department_id)
            } else {
                responseDepartment = await onGetAllDepertment()
            }
            responseDivision = await onGetDivisionByDepertmentId(responseDepartment.map(x => x.id))
            if (_profile.user_division_id) {
                responseDivision = responseDivision.filter(x => x.id === _profile.user_division_id);
            }
            setListDivisionDefault(JSON.parse(JSON.stringify(responseDivision)));
            setListDivision(JSON.parse(JSON.stringify(responseDivision)));
            setListDivisionSelect(JSON.parse(JSON.stringify(responseDivision)))
        }
        const responseProvince = await onGetAllLocation();
        setListProvince(JSON.parse(JSON.stringify(responseProvince)));
        let responseLocation = [];
        for (let item of responseProvince) {
            responseLocation = [
                ...responseLocation,
                ...item.location
            ]
        }
        setListLocation(JSON.parse(JSON.stringify(responseLocation)))
        setListLocationDefault(JSON.parse(JSON.stringify(responseLocation)))
        setListProvinceSelect(JSON.parse(JSON.stringify(responseProvince)))
        setListLocationSelect(JSON.parse(JSON.stringify(responseLocation)))
        // ========== ========== ========== ==========
        await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            orderOption.order,
            orderOption.orderBy,
            listTypeEFSelect.map(x => x.label),
            responseDepartment.map(x => x.id),
            responseDivision.map(x => x.id),
            responseProvince.map(x => x.id),
            responseLocation.map(x => x.id),
        );
        setIsLoading(false);
    }
    async function onGetData(search, limit, page, order, order_by, type, department, division, province, location) {
        let response = null;
        try {
            const body = {
                search: search,
                search_by: ["evaluation_name"],
                order: order || "ASC",
                order_by: order_by,
                limit: limit,
                page: page,
                type: [...type],
                department: [...department],
                division: [...division],
                province: [...province],
                location: [...location],
            };
            response = await CoreAPI.evaluationFormHttpService.evaluationFormGetListByParam(body)
        } catch { }
        if (response) {
            let detailPage = { ...pageOption }
            detailPage.limit = response.limit;
            detailPage.page = response.page;
            detailPage.total_item = response.total_item;
            detailPage.total_page = response.total_page;
            setPageOption(detailPage);
            setListData(response.data)
        }
        return response;
    }
    async function onDeleteData(id) {
        let response = null;
        try {
            response = await CoreAPI.evaluationFormHttpService.evaluationFormRemove(id)
        } catch { }
        let detail = {
            title: "ลบแบบสอบถามล้มเหลว",
            sub_title: "",
            type: "fail",
            button_label: "กลับหน้าหลัก",
        }
        if (response) {
            if (response.success === true) {
                detail = {
                    title: "ลบแบบสอบถามสำเร็จ",
                    sub_title: "",
                    type: "success",
                    button_label: "กลับหน้าหลัก",
                }
            }
        }
        setOpenSuccessModal(true)
        setDetailSuccessModal(detail)
    }
    async function onUpdateStatus(param) {
        let response = null;
        try {
            let body = {
                evaluation_form_id: param?.id,
                evaluation_name: param?.evaluation_name,
                status: param?.status,
            }
            response = await CoreAPI.evaluationFormHttpService.evaluationFormUpdate(body)
        } catch { }
    }
    async function onGetDepartmentById(id) {
        let response = [];
        try {
            response = await CoreAPI.userHttpService.userGetDepertmentById(id)
        } catch { }
        if (response) {
            let list = [];
            const detail = {
                id: response.department_id,
                label: response.department_name,
            }
            list.push(detail);
            response = [...list]
        }
        setListDepartment(response)
        setListDepartmentSelect(JSON.parse(JSON.stringify(response)))
        return response;
    }
    async function onGetAllDepertment() {
        let response = null;
        try {
            response = await CoreAPI.userHttpService.userGetAllDepertment()
        } catch { }
        if (response) {
            let list = [];
            if (Array.isArray(response)) {
                list = JSON.parse(JSON.stringify(response));
                list = list.map(x => {
                    const detail = {
                        id: x.department_id,
                        label: x.department_name,
                    }
                    return detail
                })
            }
            response = [...list]
        }
        setListDepartment(response)
        setListDepartmentSelect(JSON.parse(JSON.stringify(response)))
        return response;
    }
    async function onGetDivisionByDepertmentId(list) {
        let response = [];
        try {
            const body = {
                list
            }
            response = await CoreAPI.userHttpService.userGetDivisionByDepertmentId(body)
        } catch { }
        if (response) {
            if (Array.isArray(response)) {
                response = response.map(x => {
                    const detail = {
                        id: x.division_id,
                        label: x.division_name,
                        department_id: x.department_id,
                    }
                    return detail
                })
            }
        }
        return response
    }
    async function onGetAllLocation() {
        let response = [];
        try {
            response = await CoreAPI.evaluationFormHttpService.evaluationFormGetListLocationGroupByProvince()
        } catch { }
        return response;
    }

    async function handleInputSearch(param) {
        setSearch(param)
    }
    async function handleEnterSearch() {
        setIsLoading(true);
        await onGetData(
            search,
            pageOption.limit,
            1,
            orderOption.order,
            orderOption.orderBy,
            listTypeEFSelect.map(x => x.label),
            listDepartmentSelect.map(x => x.id),
            listDivisionSelect.map(x => x.id),
            listProvinceSelect.map(x => x.id),
            listLocationSelect.map(x => x.id),
        );
        setIsLoading(false);
    }
    async function handleChangePageOption(param) {
        setIsLoading(true);
        await onGetData(
            search,
            param.limit,
            param.page,
            orderOption.order,
            orderOption.orderBy,
            listTypeEFSelect.map(x => x.label),
            listDepartmentSelect.map(x => x.id),
            listDivisionSelect.map(x => x.id),
            listProvinceSelect.map(x => x.id),
            listLocationSelect.map(x => x.id),
        );
        setIsLoading(false);
    }
    async function handleChangeOrderOption(param) {
        setIsLoading(true);
        setOrderOption(param)
        await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            param.order,
            param.orderBy,
            listTypeEFSelect.map(x => x.label),
            listDepartmentSelect.map(x => x.id),
            listDivisionSelect.map(x => x.id),
            listProvinceSelect.map(x => x.id),
            listLocationSelect.map(x => x.id),
        );
        setIsLoading(false);
    }
    function handleCreate() {
        navigate('/ef-management/create-update');
    }
    function handleUpdate(param) {
        const id = param.id;
        window.open(`${process.env.REACT_APP_BASE_PATH}/ef-management/create-update/${id}`, '_blank');
        // navigate(`/ef-management/create-update/${id}`);
    }
    async function handleChangeStatus(param) {
        setIsLoading(true);
        await onUpdateStatus(param);
        await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            orderOption.order,
            orderOption.orderBy,
            listTypeEFSelect.map(x => x.label),
            listDepartmentSelect.map(x => x.id),
            listDivisionSelect.map(x => x.id),
            listProvinceSelect.map(x => x.id),
            listLocationSelect.map(x => x.id),
        );
        setIsLoading(false);
    }
    function handleDelete(param) {
        let detail = { ...detailModal };
        detail.title = "ยืนยันการลบแบบสอบถาม"
        detail.sub_title = param?.displayname
        setDetailModal(detail)
        setOpenModal(true)
        setDataFocus(param)
    }
    function handleOpenQRCode(param) {
        setOpenQRcodeModal(true)
        setDataFocus(param)
    }
    function handleCloseQRCode() {
        setOpenQRcodeModal(false)
        setDataFocus(null)
    }
    async function handleConfirmDelete() {
        let detail = { ...dataFocus }
        setOpenModal(false)
        setIsLoading(true);
        await onDeleteData(detail.id)
        const response = await onGetData(
            search,
            pageOption.limit,
            pageOption.page,
            orderOption.order,
            orderOption.orderBy,
            listTypeEFSelect.map(x => x.label),
            listDepartmentSelect.map(x => x.id),
            listDivisionSelect.map(x => x.id),
            listProvinceSelect.map(x => x.id),
            listLocationSelect.map(x => x.id),
        );
        if (response) {
            if (response.page !== 1 && response.data.length === 0) {
                await onGetData(
                    search,
                    pageOption.limit,
                    pageOption.page,
                    orderOption.order,
                    orderOption.orderBy,
                    listTypeEFSelect.map(x => x.label),
                    listDepartmentSelect.map(x => x.id),
                    listDivisionSelect.map(x => x.id),
                    listProvinceSelect.map(x => x.id),
                    listLocationSelect.map(x => x.id),
                );
            }
        }
        setIsLoading(false);
        setDataFocus(null);
    }
    async function handleSelectDepartment(params) {
        setListDepartmentSelect(params)
        let list = JSON.parse(JSON.stringify(listDivisionDefault))
        let listSelect = JSON.parse(JSON.stringify(listDivisionSelect))
        listSelect = listSelect.filter(x => {
            const model = params.find(y => y.id === x.department_id);
            return model ? true : false;
        })
        list = list.filter(x => {
            const model = params.find(y => y.id === x.department_id);
            return model ? true : false;
        })
        setListDivision(list);
        setListDivisionSelect(listSelect);
    }
    async function handleSelectDivision(params) {
        setListDivisionSelect(params)
    }
    async function handleSelectProvince(params) {
        setListProvinceSelect(params)
        let list = JSON.parse(JSON.stringify(listLocationDefault))
        let listSelect = JSON.parse(JSON.stringify(listLocationSelect))
        listSelect = listSelect.filter(x => {
            const model = params.find(y => y.id === x.province);
            return model ? true : false;
        })
        list = list.filter(x => {
            const model = params.find(y => y.id === x.province);
            return model ? true : false;
        })
        setListLocation(list);
        setListLocationSelect(listSelect);
    }
    async function handleSelectLocation(params) {
        setListLocationSelect(params)
    }
    async function handleViewDashboard(params) {
        const id = params.id;
        window.open(`${process.env.REACT_APP_BASE_PATH}/dashboard?evaluation_form_id=${id}`, '_blank');
    }

    return (
        <BackOfficeLayout>
            <LoadingModal open={isLoading} />
            <DeleteModal
                open={openModal}
                onConfirm={handleConfirmDelete}
                onBack={(e) => setOpenModal(false)}
                title={detailModal.title}
                subTitle={detailModal.sub_title}
            />
            <SuccessModal
                open={openSuccessModal}
                onConfirm={(e) => setOpenSuccessModal(false)}
                title={detailSuccessModal.title}
                type={detailSuccessModal.type}
                buttonLabel={detailSuccessModal.button_label}
            />
            <EFQRcodeModal
                open={openQRcodeModal}
                dataItem={dataFocus}
                onClose={handleCloseQRCode}
            />
            <Container>
                <div className="header-box vertical-center">
                    <div className="header-label">
                        ประวัติการสร้างแบบสอบถาม {pageOption.total_item !== 0 ? `(${pageOption.total_item})` : ""}
                    </div>
                    <ButtonComponent
                        label={"สร้างแบบสอบถาม"}
                        variant={"primary"}
                        icon={IconPlus}
                        sceenSize={"lg"}
                        style={{ width: "200px", maxWidth: "200px", minWidth: "200px" }}
                        onClick={handleCreate}
                    />
                </div>
                <div className="filter-bar">
                    <InputSearchComponent
                        styleInput={{ height: "56px" }}
                        placeholder={"ค้นหา"}
                        onEnter={handleEnterSearch}
                        onInput={handleInputSearch}
                    />
                    <div className="multi-box">
                        <div className="multi-select">
                            <DropdownFilterComponent
                                label={"ประเภทแบบสอบถาม"}
                                placeholder={"เลือกประเภทแบบสอบถาม"}
                                list={listTypeEF}
                                value={listTypeEFSelect}
                                mode={"multi"}
                                onSelect={(e) => setListTypeEFSelect(e)}
                            />
                            <div className="line"></div>
                            <DropdownFilterComponent
                                label={"ฝ่าย"}
                                placeholder={"เลือกฝ่าย"}
                                list={listDepartment}
                                value={listDepartmentSelect}
                                mode={"multi"}
                                onSelect={handleSelectDepartment}
                            />
                            <div className="line"></div>
                            <DropdownFilterComponent
                                label={"กอง"}
                                placeholder={"เลือกกอง"}
                                list={listDivision}
                                value={listDivisionSelect}
                                mode={"multi"}
                                onSelect={handleSelectDivision}
                            />
                        </div>
                        <div className="vertical-center" style={{ width: "156px", minWidth: "156px", paddingTop: "20px" }}>
                            {!listTypeEFSelect.find(x => x.id === 1) &&
                                <ButtonComponent
                                    label={"ค้นหา"}
                                    variant={"secondary"}
                                    sceenSize={"lg"}
                                    style={{ width: "156px", maxWidth: "156px", minWidth: "156px" }}
                                    onClick={handleEnterSearch}
                                />
                            }
                        </div>
                    </div>
                    {listTypeEFSelect.find(x => x.id === 1) &&
                        <div className="multi-box">
                            <div className="multi-select">
                                <DropdownFilterComponent
                                    label={"จังหวัด"}
                                    placeholder={"เลือกจังหวัด"}
                                    list={listProvince}
                                    value={listProvinceSelect}
                                    mode={"multi"}
                                    onSelect={handleSelectProvince}
                                />
                                <div className="line"></div>
                                <DropdownFilterComponent
                                    label={"สถานที่"}
                                    placeholder={"เลือกสถานที่"}
                                    list={listLocation}
                                    value={listLocationSelect}
                                    mode={"multi"}
                                    onSelect={handleSelectLocation}
                                />
                            </div>
                            <div className="vertical-center" style={{ width: "156px", minWidth: "156px", paddingTop: "20px" }}>
                                <ButtonComponent
                                    label={"ค้นหา"}
                                    variant={"secondary"}
                                    sceenSize={"lg"}
                                    style={{ width: "156px", maxWidth: "156px", minWidth: "156px" }}
                                    onClick={handleEnterSearch}
                                />
                            </div>
                        </div>
                    }
                </div>
                <div className="data-box">
                    <TableEFComponent
                        listData={listData}
                        order={orderOption}
                        onOrder={handleChangeOrderOption}
                        onDelete={handleDelete}
                        onUpdate={handleUpdate}
                        onChangeStatus={handleChangeStatus}
                        onOpenQRCode={handleOpenQRCode}
                        onViewDashboard={handleViewDashboard}
                    />
                    <PaginatorComponent
                        limit={pageOption.limit}
                        page={pageOption.page}
                        total_item={pageOption.total_item}
                        total_page={pageOption.total_page}
                        onChangePageOption={handleChangePageOption}
                    />
                </div>
            </Container>
        </BackOfficeLayout>
    )
}

export default EFManagementPage;